// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"b30ce000","187":"d5373a1a","221":"2b843c38","274":"1258d863","451":"350fdb61","453":"e10a4461","555":"d1471af7","591":"7a739e9d","665":"f803fa82","818":"c5d6c5bd","890":"d78c28a2","891":"4189774a","932":"d307e83c","936":"2e2cbba7"}[chunkId] + ".chunk.js";
};